module.exports = __webpack_public_path__ + "static/media/like.f21653dd.svg";